const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveryTruck7656486(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 87.2,
    y1: 334.604,
    x2: 87.2,
    y2: 239.624
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 86.2,
    y1: 220.164,
    x2: 86.2,
    y2: 220.054
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 143.08,
    y1: 334.604,
    x2: 143.08,
    y2: 258.584
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 199.94,
    y1: 334.604,
    x2: 199.94,
    y2: 258.584
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 255.82,
    y1: 334.604,
    x2: 255.82,
    y2: 239.624
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 256.82,
    y1: 220.154,
    x2: 256.82,
    y2: 220.054
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 406.346,
    y1: 411.625,
    x2: 406.346,
    y2: 411.738
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 115.865,
    y1: 411.568,
    x2: 115.865,
    y2: 411.681
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M115.865,371.086c22.469,0,40.701,18.184,40.701,40.596c0,22.411-18.231,40.596-40.701,40.596s-40.701-18.184-40.701-40.596 C75.164,389.27,93.396,371.086,115.865,371.086L115.865,371.086z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M324.461,415.965H214.446h-58.108 M75.392,415.965H14.013c-3.584,0-6.513-2.922-6.513-6.496v-23.461 c0-3.574,2.93-6.496,6.513-6.496h77.05 M140.667,379.511h73.779h110.015"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M406.346,371.086c22.469,0,40.701,18.184,40.701,40.596c0,22.411-18.231,40.596-40.701,40.596s-40.701-18.184-40.701-40.596 C365.645,389.27,383.876,371.086,406.346,371.086L406.346,371.086z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M324.461,379.511v36.454h40.16 M446.819,415.965h46.389v-44.879 M493.208,335.057V306.66c-0.341-12.199,0-13.702-7.765-25.475 l-44.797-72.198c-5.376-8.652-10.154-9.362-16.724-9.362h-99.463"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M496.195,371.086c4.551,0,8.305-3.716,8.305-8.284v-19.461c0-4.539-3.754-8.284-8.305-8.284h-2.986h-11.775 c-9.955,0-18.061,8.113-18.061,18.014c0,9.901,8.106,18.014,18.061,18.014h11.775H496.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M459.305,239.086h-57.88c-9.813,0-17.89,8.028-17.89,17.844v31.887c0,9.816,8.078,17.844,17.89,17.844h91.783"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M218.983,88.357c-7.505-4.452-15.707-7.875-24.412-10.101v-9.934c0-4.731-3.878-8.599-8.621-8.599h-28.876 c-4.743,0-8.621,3.868-8.621,8.599v9.934c-8.705,2.226-16.907,5.649-24.412,10.101l-7.059-7.04c-3.348-3.339-8.844-3.339-12.192,0 l-20.422,20.369c-3.376,3.339-3.376,8.821,0,12.188l7.059,7.012c-4.464,7.513-7.923,15.695-10.127,24.349h-9.96 c-4.743,0-8.649,3.868-8.649,8.599v28.801c0,4.731,3.906,8.626,8.649,8.626h9.96c2.204,8.654,5.664,16.835,10.127,24.321 l-7.059,7.04c-3.376,3.339-3.376,8.821,0,12.188l20.422,20.342c3.348,3.367,8.844,3.367,12.192,0l7.059-7.012 c7.505,4.452,15.707,7.875,24.412,10.073v9.934c0,4.758,3.878,8.626,8.621,8.626h28.876c4.743,0,8.621-3.868,8.621-8.626v-9.934 c8.705-2.198,16.907-5.621,24.412-10.073l7.059,7.012c3.348,3.367,8.844,3.367,12.192,0l20.422-20.342 c3.376-3.367,3.376-8.849,0-12.188l-7.059-7.04c4.464-7.485,7.923-15.667,10.127-24.321h9.96c4.743,0,8.649-3.896,8.649-8.626 v-28.801c0-4.731-3.906-8.599-8.649-8.599h-9.96c-2.204-8.654-5.664-16.835-10.127-24.349l7.059-7.012 c3.376-3.367,3.376-8.849,0-12.188l-20.422-20.369c-3.348-3.339-8.844-3.339-12.192,0L218.983,88.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M324.461,379.511v-81.418 M324.461,263.426v-79.943c0-2.865-2.361-5.22-5.262-5.22h-36.747 M60.573,178.263H23.826 c-2.901,0-5.262,2.355-5.262,5.22v79.943 M18.564,298.093v81.418"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M171.498,217.392c-27.202,0-49.27-22.011-49.27-49.143c0-27.159,22.068-49.171,49.27-49.171c27.23,0,49.298,22.011,49.298,49.171 C220.796,195.38,198.728,217.392,171.498,217.392L171.498,217.392z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryTruck7656486);
export default __webpack_public_path__ + "static/media/delivery-truck_7656486.4e7d963c02ebb9f5f08c983571f6d085.svg";
export { ForwardRef as ReactComponent };